import ProductCard from '@components/cards/ProductCard';
import UserContext from '@context/UserContext';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { RoomShoppable } from '@pages/shop/homes/[home]/home';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import IconFullArrowRight from '@ui/icons/imaterial/arrows/Full Arrow Right.svg';
import theme from '@ui/theme';
import onSavedClickProduct from '@utils/clickHandlers/onSavedClickProduct';
import Link from 'next/link';
import React, { useContext } from 'react';

import useStyles from './ShoppableRoomProducts.style';

type ShoppableRoomProductsProps = {
  pseudoRoom: RoomShoppable;
}

const ShoppableRoomProducts: React.FC<ShoppableRoomProductsProps> = (props) => {
  const { classes } = useStyles();
  const { md } = useBreakpoints();
  const { pseudoRoom } = props;
  const { productCount, cartRoomProduct } = pseudoRoom;
  let cartProducts: guesthouse.CartProduct[];

  if (cartRoomProduct?.cartProducts?.length) {
    cartProducts = cartRoomProduct.cartProducts;
  } else {
    cartProducts = [];
  }

  const userContext = useContext<UserContext>(UserContext);

  if (!pseudoRoom.roomDocID) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
    >
      <Typography
        component="div"
        style={{
          fontFamily: theme.typography.fontFamily,
          color: theme.palette.text.primary,
          fontSize: 14,
          fontWeight: 500,
          padding: md ? theme.spacing(3, 0, 1.5) : theme.spacing(3, 3, 1.5),
        }}
      >
        {`${pseudoRoom.title} - ${productCount} product${productCount === 1 ? '' : 's'}`}
      </Typography>
      <Grid
        container
        spacing={.5}
        padding={md ? 0 : theme.spacing(0, 3)}
      >
        {cartProducts.length > 0 && cartProducts.map((cartProduct: guesthouse.CartProduct, i) => {
          const savedProduct = userContext.savedProducts?.ids.indexOf(cartProduct.product?.docID) > -1;

          if (!cartProduct?.product?.offers?.length) {
            return null;
          }

          return (
            <Grid
              key={`${cartProduct.product.docID}_${i}`}
              item
              xs={6}
              lg={4}
              xl={3}
            >
              <ProductCard
                product={cartProduct.product}
                saved={savedProduct}
                enableQuickView={true}
                showMaker={false}
                showDiscount={false}
                onSavedClick={async () => onSavedClickProduct(userContext, savedProduct, cartProduct.product as guesthouse.Product)}
              />
            </Grid>
          );
        })}
        <Grid
          item
          xs={6}
          lg={4}
          xl={3}
        >        
          <Link
            href="/design"
            className={classes.designLinkAnchorTag}
          >

            <div className={classes.designLinkCard}>
              <Typography
                variant="h2"
                className={classes.designLinkTextTitle}
              >
                Buying a home?
              </Typography>
              <Typography
                variant="h3"
                className={classes.designLinkTextBody}
              >
                Let our expert
                <br /> 
                designers help curate
                <br />
                your new space

                <IconFullArrowRight 
                  style={{
                    height: 28,
                    width: 28,
                    position: 'relative',
                    top: 10,
                  }}
                />
              </Typography>
            </div>

          </Link>
        </Grid>
      </Grid>
    </Box>
  );
};

export default React.memo(ShoppableRoomProducts);
